var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-bar',{on:{"toggle:sideBar":_vm.toggleSideBar}}),(_vm.isShownGroupsSideBar)?_c('groups-side-bar',{model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }